import { useAuthProvider } from 'context/auth/AuthProvider'
import { ModelContext } from 'context/model/ModelContext'
import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRootNodesQuery } from '../../../apollo/configurator/queries/RootNodes.generated'
import { GalleryContext } from '../../../context/gallery/GalleryContext'
import Manager from '../organisms/Manager'

const ModelDetailTemplate = () => {
    const { state, setGalleryState } = useContext(GalleryContext)
    const { state: modelState, setState: setModelState } = useContext(ModelContext)
    const { permissions, isLoading } = useAuthProvider()
    const { code } = useParams<{ code: string }>()
    const { data } = useRootNodesQuery()

    useEffect(() => {
        setGalleryState({ ...state, isUploading: false })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // disabled because this breaks selecting a model

    useEffect(() => {
        if (code && data?.configuratorNodes) {
            const model = data.configuratorNodes.find((node) => node.code === code)
            if (model && model.id !== modelState.currentModel) {
                setModelState({
                    currentModel: model.id,
                    currentModelCode: model.code || '',
                    hasChanges: false,
                    hasEdited: false,
                    updatedModel: false,
                    showEditedMessage: false
                })
            }
        }
    }, [code, data, modelState.currentModel, setModelState])

    if (isLoading) {
        return <></>
    }

    return permissions?.['Model']?.length ? <Manager /> : <></>
}

export default ModelDetailTemplate
